import {Order} from '../../types';
import { deliveryDateTypes } from "../../static_data/deliveryDateTypes";
import { isDayDelivery } from '../order/isDayDelivery';
import { hasDeliveryDate } from '../order/hasDeliveryDate';
export function filterDayDeliveries(orders : Order[], returnRest = false) : Order[]{

    if(returnRest) return orders.filter(order => !isDayDelivery(order) || !hasDeliveryDate(order));
    return orders.filter(isDayDelivery).filter(hasDeliveryDate)

}       